// extracted by mini-css-extract-plugin
module.exports = {"reviews":"styles_reviews__93r1Z","heading":"styles_heading___N_a2","subheading":"styles_subheading__ldD44","grid":"styles_grid__8vRnw"};